import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { i18n } from '../../../translate/i18n';
import { isEmpty } from 'lodash';
import {
  Paper, Typography, FormControl, IconButton, Container, TextField, FormControlLabel,
  Switch, Divider, useMediaQuery, MenuItem, Select, InputLabel,
} from '@mui/material';
import confirm from '../../../UI/Confirm/confirm';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import ArrowBack from '@mui/icons-material/ArrowBack';
import DeleteIcon from '@mui/icons-material/Delete';

import * as actions from "../../../store/actions";

import {
  FormStyled, DoneIconStyled, DivSubmitButtons,
  DivFormTitle,
} from './styles';

import Spinner from '../../../components/Spinner/index';
import { deleteCheckMessage } from '../../../utils/deleteCheckMessage';


const FormFrequency = (props) => {
  const dispatch = useDispatch();
  const matches = useMediaQuery('(min-width:1200px)');

  const [editMode, setEditMode] = useState(false);
  const [isNewData, setIsNewData] = useState(true);

  // forms do empresas
  const [name, setName] = useState("");
  const [value, setValue] = useState(1);
  const [type, setType] = useState('month');
  const [onDemand, setOnDemand] = useState(false);

  //error forms
  const [nameError, setNameError] = useState(false);
  const [valueError, setValueError] = useState(false);

  const fetchFrequency = useCallback(
    () => dispatch(actions.fetchFrequencyById(props.match.params.id))
  );

  //get from redux
  const frequency = useSelector(state => state.frequency.frequency);
  const loadingFrequency = useSelector(state => state.frequency.loading);

  const checkDeleteFrequency = () => dispatch(actions.checkDeleteFrequency(props.match.params.id))
  const deleteFrequency = () => dispatch(actions.deleteFrequency(props.match.params.id))


  //check if is newEntrance or editing
  useEffect(() => {
    setIsNewData(props.match.params.id === 'new')
    if (props.match.params.id !== 'new') {
      fetchFrequency()
    }
  }, [])

  // in case editing, populate fields
  useEffect(() => {
    if (!isEmpty(frequency) && props.match.params.id !== 'new') {
      setName(frequency.name)
      setValue(frequency.amount)
      setOnDemand(frequency.onDemand)
      setType(frequency.type)
    }
  }, [frequency])


  //send data to Server (post and update)
  const postFrequency = (body) => dispatch(actions.postFrequency(body))
  const updateFrequency = (body) => dispatch(actions.updateFrequency(props.match.params.id, body))

  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!name) {
      setNameError(true);
      hasError = true
    }

    if (!value || value <= 0) {
      setValueError(true);
      hasError = true
    }

    if (hasError) return;

    const body = {
      "name": name,
      "amount": value,
      "onDemand": onDemand,
      "type": type
    }

    if (isNewData) {
      postFrequency(body).then(result => {
        if (result === 'success') {
          props.history.goBack()
        }
      })
    } else {
      updateFrequency(body).then(result => {
        if (result === 'success') {
          props.history.goBack()
        }
      })
    }
  }

  const handleBack = () => {
    props.history.goBack()
  }

  const handleCloseComparison = () => {
    return (
      (name !== frequency.name) ||
      (value !== frequency.amount) ||
      (type !== frequency.type) ||
      (onDemand !== frequency.onDemand)
    );
  }

  const handleCloseRestoreDefault = () => {
    setName(frequency.name)
    setValue(frequency.amount)
    setOnDemand(frequency.onDemand)
    setType(frequency.type)
  }

  const handleClose = () => {
    // verifica se algo foi alterado
    if (handleCloseComparison()) {
      confirm(i18n.t('handleCloseFormParamFreq.confirm'),
        {
          title: i18n.t('handleCloseFormParamFreq.title'),
          titleColor: 'red',
          disableBackdrop: true
        })
        .then(
          () => {
            console.log('continue editing');
          },
          async () => {
            handleCloseRestoreDefault();
            setEditMode(false)
          },
        )
    } else {
      setEditMode(false)
    }
  }

  const checkDeleteFrequencyCall = (documentName) => {
    checkDeleteFrequency().then((res) => {
      if (isEmpty(res)) {
        handleDeleteFrequency(documentName)
      } else {
        handleDeleteFrequencyFail(res)
      }
    })
  }

  const handleDeleteFrequency = (docName) => {
    confirm(`${i18n.t('handleDeleteFrequencyFormParamFreq.confirm')} ${docName}?`,
      {
        title: i18n.t('handleDeleteFrequencyFormParamFreq.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
          deleteFrequency().then(() => {
            props.history.goBack()
          })
        },
      )
  }

  const handleDeleteFrequencyFail = (obj) => {
    confirm(`${deleteCheckMessage(obj)}`,
      {
        title: i18n.t('handleDeleteFrequencyFailFormParamFreq.title'),
        titleColor: 'red',
        disableBackdrop: true
      }).then(
        () => { },
        async () => {
        },
      )
  }

  const handleChangeType = event => {
    setType(event.target.value);
  };
  const handleChangeDemand = event => {
    setOnDemand(event.target.checked);
  };

  return <>
    <IconButton onClick={handleBack} style={styles.arrowBack} size="large"><ArrowBack /></IconButton>
    <div style={matches ? styles.divContainer : styles.divContainerSmall}>
      <Container maxWidth='sm' style={styles.container}>
        {loadingFrequency && <Spinner overlay />}
        <Paper>
          <FormStyled onSubmit={handleSubmit} style={{ opacity: loadingFrequency ? '0.3' : '1' }}>
            <DivFormTitle>
              <Typography variant='h6'>{props.match.params.id === 'new' ? i18n.t('typographyFormParamFreq.true') : i18n.t('typographyFormParamFreq.false')}</Typography>
              {!isNewData &&
                <DivSubmitButtons>
                  {editMode ?
                    <>
                      <IconButton onClick={handleClose} size="large"><CloseIcon color='error' /></IconButton>
                      <IconButton type="submit" size="large"><DoneIconStyled /></IconButton>
                    </> :
                    <>
                      <IconButton onClick={() => setEditMode(true)} size="large"><EditIcon /></IconButton>
                      <IconButton onClick={() => checkDeleteFrequencyCall(name)} size="large"><DeleteIcon /></IconButton>
                    </>
                  }
                </DivSubmitButtons>
              }
            </DivFormTitle>
            <Divider />
            <div style={styles.inputsContainer}>
              <FormControl variant="standard" fullWidth>
                <TextField
                  variant="standard"
                  autoFocus
                  disabled={!isNewData && !editMode}
                  label={i18n.t('textFieldFormParamFreq.name')}
                  name='name'
                  onChange={event => { setNameError(false); return setName(event.target.value.toUpperCase()) }}
                  value={name}
                  error={nameError}
                  margin='normal' />
              </FormControl>

              <FormControl variant="standard" margin='normal' fullWidth>
                <FormControlLabel
                  control={
                    <Switch
                      disabled={!isNewData && !editMode}
                      checked={onDemand}
                      onChange={handleChangeDemand}
                      color="primary"
                    />
                  }
                  label={i18n.t('formControlLabelFormControlAbel.label')}
                />
              </FormControl>

              {!onDemand &&
                <>
                  <FormControl variant="standard" style={{ width: 75 }}>
                    <TextField
                      variant="standard"
                      disabled={(!isNewData && !editMode) || onDemand}
                      type='number'
                      label={i18n.t('textFieldFormParamFreq.value')}
                      name='qnt'
                      onChange={event => { setValueError(false); return setValue(event.target.value) }}
                      value={value}
                      error={valueError}
                      helperText={valueError ? 'valor > 0' : ''}
                      margin='normal' />
                  </FormControl>

                  <FormControl variant="standard" margin='normal' style={{ marginLeft: 10 }}>
                    <InputLabel id="demo-simple-select-label">{i18n.t('inputLabelFormParamEquip.label')}</InputLabel>
                    <Select
                      variant="standard"
                      disabled={(!isNewData && !editMode) || onDemand}
                      id="demo-simple-select"
                      value={type}
                      onChange={handleChangeType}>
                      <MenuItem value={'day'}>{i18n.t('menuItemFormParamFreq.day')}</MenuItem>
                      <MenuItem value={'month'}>{i18n.t('menuItemFormParamFreq.month')}</MenuItem>
                      {/* <MenuItem value={'year'}>anos</MenuItem> */}
                    </Select>
                  </FormControl>
                </>
              }

            </div>

            {isNewData &&
              <DivSubmitButtons>
                <IconButton onClick={props.history.goBack} size="large"><CloseIcon fontSize='large' color='error' /></IconButton>
                <IconButton type="submit" size="large"><DoneIconStyled fontSize='large' /></IconButton>
              </DivSubmitButtons>}
          </FormStyled>
        </Paper>
      </Container>
    </div>
  </>;
}

export default FormFrequency;

const styles = {
  arrowBack: {
    position: 'fixed',
    marginTop: 10,
  },
  divContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    marginBottom: 50,
  },
  divContainerSmall: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center'
  },
  container: {
    padding: 10,
    margin: 0,
    marginLeft: 50,
    position: 'relative'
  },
  avatarContainer: {
    display: 'flex',
    padding: 20,
    alignItems: 'center',
    justifyContent: 'center',
  },
  avatar: {
    width: 150,
    height: 150,
    marginTop: 20,
  },
  avatarButton: {
    margin: 5,
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  imageInput: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column'
  },
  inputsContainer: {
    marginTop: 10,
  }
}


